import { config } from "@/config";
import useBalanceStore from "@/stores/user/balance.store";
import { createContext, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useGameStatsStore from "@/stores/gamestats/store";
import useNotificationStore from "@/stores/notification/notification.store.ts";
import useUserStore from "@/stores/authentication/store";
import { useGetAccountData } from "@/services/profile.service";
import { profileApi } from "@/services";
import useSelfExclusionStore from "@/stores/selfexclusion/store";
import Cookies from "js-cookie";

interface ISSEData {
  event: string;
  wonAmount?: number;
  betAmount?: number;
  round?: string;
  tier?: string;
  balance?: string;
  bonusBalance?: string;
  nativeTokenBalance?: string;
}

export const context = createContext({});

export default function SSEProvider({ children }: any) {
  const refreshGameStats = useGameStatsStore((state) => state.refreshStats);
  const fetchNotifications = useNotificationStore(
    (state) => state.fetchNotifications,
  );
  const { setData, data, logout, isAuthenticated } = useUserStore();
  const balanceStore = useBalanceStore();

  const {
    data: userQuery,
    isError,
    isSuccess,
    error,
    refetch,
  } = useGetAccountData();
  const requestSelfExclusion = profileApi.useRequestSelfExclusion();
  const setSsSelfExclusion = useSelfExclusionStore(
    (state) => state.setSelfExclusion,
  );
  useEffect(() => {
    if (isError && (error as any).status !== 403) {
      logout();
      return;
    }

    refetch();

    if (isSuccess) {
      setData(userQuery?.data?.data);
      balanceStore.setBalance(parseInt(userQuery?.data?.data?.balance));
      balanceStore.setNativeBalance(
        parseInt(userQuery?.data?.data?.nativeBalance),
      );
    }
  }, [isSuccess, isError]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchNotifications();

      const token = Cookies.get("jwtToken") as string;
      if (!token) return;

      const evtSource = new EventSource(
        `${config.apiUrl}/deposit/sse?token=${token}`,
      );

      evtSource.onmessage = (event) => {
        if (event.data) {
          balanceStore.refreshBalance();
          const parsedData: ISSEData = JSON.parse(event.data);

          if (parsedData.event == "DEPOSIT") {
            toast("Successfully Deposited");
          }
          if (parsedData.event == "REFRESH") {
            setData({
              ...data,
              balance: Number(parsedData.balance) || 0,
              bonusBalance: Number(parsedData.bonusBalance) || 0,
              neoBalance: Number(parsedData.nativeTokenBalance) || 0,
            });
            balanceStore.setBalance(Number(parsedData.balance) || 0);
            balanceStore.setBonusBalance(Number(parsedData.bonusBalance) || 0);
            balanceStore.setNativeBalance(
              Number(parsedData.nativeTokenBalance) || 0,
            );
          }
          if (parsedData.event == "LIVE_STATS") {
            refreshGameStats();
          }
          if (parsedData.event == "PREDICTION_WON") {
            toast(`You have won a prediction round!`);
          }
          if (parsedData.event == "PREDICTION_LOSE") {
            toast(`You have lost a prediction round!`);
          }
          if (parsedData.event == "PROMOTED") {
            toast(`You have promoted this tier ${parsedData.tier}`);
          }
          if (parsedData.event == "NOTIFICATION") {
            fetchNotifications();
          }
        }
      };
    }
  }, []);

  return <context.Provider value={{}}>{children}</context.Provider>;
}
